import { render, staticRenderFns } from "./CountryTable.vue?vue&type=template&id=5c10e426&scoped=true"
import script from "./CountryTable.vue?vue&type=script&lang=js"
export * from "./CountryTable.vue?vue&type=script&lang=js"
import style0 from "./CountryTable.vue?vue&type=style&index=0&id=5c10e426&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c10e426",
  null
  
)

export default component.exports